import * as React from "react";
import { useNotify } from "react-admin";
import {
  Box, Card, CardContent, Typography, TextField, Button, Tabs, Tab,
  CircularProgress, Alert, Table, TableHead, TableBody, TableRow, TableCell,
} from "@mui/material";
import ReceiptIcon from "@mui/icons-material/Receipt";
import { httpClient } from "../../api/httpClient";
import { API_BASE_URL } from "../../api/config";
import { DocumentDownloadButton } from "../../components/DocumentDownloadButton";

const FacturesList = () => {
  const [mode, setMode] = React.useState(0);
  const [id, setId] = React.useState("");
  const [list, setList] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const notify = useNotify();

  const fetch = async () => {
    if (!id.trim()) return;
    setLoading(true);
    try {
      const path = mode === 0
        ? `documents/patient/${id}/factures`
        : `documents/pro/${id}/factures`;
      const { json } = await httpClient(`${API_BASE_URL}/${path}`);
      setList(Array.isArray(json) ? json : json?.data || []);
    } catch (e) {
      notify(`Erreur : ${e.message}`, { type: "error" });
      setList([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h4" sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
        <ReceiptIcon /> Factures
      </Typography>
      <Alert severity="info" sx={{ mb: 2 }}>
        Liste des factures par patient ou par professionnel.
      </Alert>
      <Tabs value={mode} onChange={(_, v) => setMode(v)} sx={{ mb: 2 }}>
        <Tab label="Par patient" />
        <Tab label="Par pro" />
      </Tabs>
      <Card sx={{ mb: 2 }}>
        <CardContent>
          <Box sx={{ display: "flex", gap: 2 }}>
            <TextField size="small"
              label={mode === 0 ? "ID patient" : "ID pro"}
              value={id} onChange={(e) => setId(e.target.value)} />
            <Button variant="contained" onClick={fetch} disabled={loading || !id.trim()}>
              {loading ? <CircularProgress size={18} /> : "Charger"}
            </Button>
          </Box>
        </CardContent>
      </Card>
      <Card>
        <CardContent>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>ID</TableCell>
                <TableCell>Numéro</TableCell>
                <TableCell>Montant</TableCell>
                <TableCell>Date</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {list.length === 0 ? (
                <TableRow><TableCell colSpan={5} align="center">Aucune facture</TableCell></TableRow>
              ) : list.map((f, i) => (
                <TableRow key={f.id || i}>
                  <TableCell>{f.id}</TableCell>
                  <TableCell>{f.invoiceNumber || f.number}</TableCell>
                  <TableCell>{f.amount} {f.currency || "EUR"}</TableCell>
                  <TableCell>
                    {f.createdAt ? new Date(f.createdAt).toLocaleDateString("fr-FR") : "—"}
                  </TableCell>
                  <TableCell>
                    {/* download-url renvoie l'URL en texte brut */}
                    <DocumentDownloadButton documentId={f.id} />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </Box>
  );
};

export default { list: FacturesList };
